'use strict';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import {IonKeyboardAttach} from '../../../_libs/reactionic/src/components/ionKeyboardAttach';
import fuse from '../../../_libs/redux-fusion';
import {requestToButtonState} from '../../../core-utilities/redux-request/utils';
import {getLoginUser, getResetPassword, getSignupUser} from '../../reducers/state';
import {loginUserRequest} from '../../redux/loginUser';
import {resetPasswordRequest} from '../../redux/resetPassword';
import {signupUserRequest} from '../../redux/signupUser';
import {AuthFormComponent} from './AuthFormComponent';

const defaultKeyboardStyle = {};

const StreamedComponent = (state$, dispatch) => (props$) => {
  const onLogin = payload => dispatch(loginUserRequest.actions.sendRequest(payload));
  const onResetPassword = payload => dispatch(resetPasswordRequest.actions.sendRequest(payload));
  const onSignup = payload => dispatch(signupUserRequest.actions.sendRequest(payload));

  const loginUserMode$ = state$
    .map(getLoginUser)
    .map(requestToButtonState)
    .distinctUntilChanged();

  const loginUserErrorCode$ = state$
    .map(getLoginUser)
    .map(state => state.err)
    .distinctUntilChanged();

  const resetPasswordMode$ = state$
    .map(getResetPassword)
    .map(requestToButtonState)
    .distinctUntilChanged();

  const signupUserMode$ = state$
    .map(getSignupUser)
    .map(requestToButtonState)
    .distinctUntilChanged();

  const keyboardStyle$ = props$
    .map(props => props.keyboardHeight)
    .distinctUntilChanged()
    .map(getKeyboardStyle);

  return props$
    .combineLatest(
      loginUserMode$,
      loginUserErrorCode$,
      signupUserMode$,
      resetPasswordMode$,
      keyboardStyle$,
      (props, loginUserMode, loginUserErrorCode, signupUserMode, resetPasswordMode, keyboardStyle) => ({
        ...props,
        loginUserMode,
        loginUserErrorCode,
        signupUserMode,
        resetPasswordMode,
        keyboardStyle,
        onLogin,
        onSignup,
        onResetPassword,
      }));
};

export const AuthFormContainer = IonKeyboardAttach(fuse(StreamedComponent)(AuthFormComponent));

// Exposed for testing. Do not import in-app
export function getKeyboardStyle(keyboardHeight) {
  return keyboardHeight === 0
    ? defaultKeyboardStyle
    : {paddingBottom: keyboardHeight + 'px'};
}



// WEBPACK FOOTER //
// ./src/js/auth/components/AuthForm/AuthFormContainer.js